import { FC } from "react";
import { Button, ButtonVariant, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";

type Props = {
  opened: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const DecisionConfirmationModal: FC<Props> = ({
  opened,
  onClose,
  onContinue
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[366px] items-center flex flex-col p-6 shadow-lg border border-alpha-100"
    >
      <div className="mb-6 rounded-full bg-danger-50 p-4">
        <InfoCircle className="text-primary-500 stroke-danger-500" size="32" />
      </div>
      <p className="mb-4 text-center text-xl font-bold text-content-1000">
        Making decision will cancel incomplete applications
      </p>
      <p className="mb-6 text-center text-sm text-content-1000">
        By making this decision, all incomplete
        <br />
        applications will be automatically canceled. This action cannot be
        undone
      </p>
      <div className="flex w-full gap-2.5">
        <div className="flex-grow">
          <Button className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className="flex-grow">
          <Button
            className="w-full"
            variant={ButtonVariant.PRIMARY}
            onClick={onContinue}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
